import apiHeader from '@/helpers/apiHeader';

const checkDuplicateService = {
  // POST /request-pool/catalouging-form/check-duplicate/{type}
  // body: { spn } untuk part_number, { long_desc } untuk description.
  // type duplicate_by_* tanpa body.
  list(type, params = {}, body = {}) {
    return apiHeader.post(`request-pool/catalouging-form/check-duplicate/${type}`, body, { params });
  },

  // Generate (trigger penghitungan) duplicate, mengembalikan total per tipe.
  // Response: { data: { description_total, manref_total } }
  generateDuplicate() {
    return apiHeader.get('request-pool/catalouging-form/generate-duplicate');
  },

  exportDuplicate(type) {
    return apiHeader.get(`request-pool/catalouging-form/export-duplicate/${type}`, {
      responseType: 'blob'
    });
  },
};

export default checkDuplicateService;
